export const BENEFIT_STATUS = {
	PENDING: 0,
	ENABLING: 1,
	ACTIVE: 2,
	INACTIVE: 3,
	NON_OPTING: 4,
	REJECTED: 5
};

export const BENEFIT_STATUS_OPTIONS = [
	{ value: "", label: "Todos" },
	{ value: String(BENEFIT_STATUS.ACTIVE), label: "Ativo" },
	{ value: String(BENEFIT_STATUS.ENABLING), label: "Habilitando" },
	{ value: String(BENEFIT_STATUS.INACTIVE), label: "Inativo" },
	{ value: String(BENEFIT_STATUS.NON_OPTING), label: "Não optante" },
	{ value: String(BENEFIT_STATUS.PENDING), label: "Pendente" },
	{ value: String(BENEFIT_STATUS.REJECTED), label: "Rejeitado" }
];

export const PARTNER_OPTIONS = [
	{ value: "", label: "Todos" },
	{ value: "GAZIN", label: "Gazin" },
	{ value: "CENTAURO", label: "Centauro" }
];

export const BENEFIT_FORM_PARTNER_OPTIONS = [
	{ value: "", label: "Nenhum" },
	{ value: "GAZIN", label: "Gazin" },
	{ value: "CENTAURO", label: "Centauro" }
];

export const BENEFIT_FORM_STATUS_OPTIONS = [
	{ value: String(BENEFIT_STATUS.PENDING), label: "Pendente" },
	{ value: String(BENEFIT_STATUS.ENABLING), label: "Habilitando" },
	{ value: String(BENEFIT_STATUS.ACTIVE), label: "Ativo" },
	{ value: String(BENEFIT_STATUS.INACTIVE), label: "Inativo" },
	{ value: String(BENEFIT_STATUS.REJECTED), label: "Rejeitado" }
];

export const STATUS_META = {
	[BENEFIT_STATUS.PENDING]: {
		label: "Pendente",
		color: "#c4c600"
	},
	[BENEFIT_STATUS.ENABLING]: {
		label: "Habilitando",
		color: "#fd7e14"
	},
	[BENEFIT_STATUS.ACTIVE]: {
		label: "Ativo",
		color: "#28a745"
	},
	[BENEFIT_STATUS.INACTIVE]: {
		label: "Inativo",
		color: "#e11d2e"
	},
	[BENEFIT_STATUS.NON_OPTING]: {
		label: "Não optante",
		color: "#584c9c"
	},
	[BENEFIT_STATUS.REJECTED]: {
		label: "Rejeitado",
		color: "#e11d2e"
	}
};

export const EMPTY_FILTERS = {
	name: "",
	cpf: "",
	company: "",
	partner: "",
	lifeInsuranceStatus: "",
	ditStatus: ""
};

export const getStatusMeta = status =>
	STATUS_META[Number(status)] || STATUS_META[BENEFIT_STATUS.PENDING];

export const formatPartner = partner => {
	if (!partner) return "—";
	if (String(partner).toUpperCase() === "GAZIN") return "Gazin";
	if (String(partner).toUpperCase() === "CENTAURO") return "Centauro";
	if (String(partner).toUpperCase() === "BOTH") return "Ambos";
	return partner;
};
